import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// import App from "./App";
// import DeductionsWidget from "./App";
import AuthForm from "./AuthForm";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
    //  <App  />
    <>
    {/* <DeductionsWidget /> */}
     <Toaster position="top-right" reverseOrder={false} />
    <AuthForm />
    </>
 );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
